import requestApi from "@/utils/requestApi";
import { mapState } from "vuex";

export default {
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      goods: {},
      goodsTem: {},
      specialList: [],
      specGroupInfo: [],
      loading: false,
      activityName: "",
      skuSpecsList: [],
      skuSpecsIndex: 0,
    };
  },
  computed: {
    ...mapState("cart", ["specsInfo"]),
    visibleSync: {
      get() {
        const { visible, goods } = this.specsInfo;
        this.goods = goods;
        this.goodsTem = goods;
        if (visible) {
          this.loading = true;

          requestApi
            .post("sctrading/goodsspu/onSale", {
              id: goods.spuId,
              source: "CART",
            })
            .then((res) => {
              const {
                data: { specialList, specGroupInfo },
              } = res;
              this.specialList = specialList;
              this.specGroupInfo = specGroupInfo;
              const goodsListTem = [];
              specGroupInfo.forEach((item) => {
                item.skuResList.forEach((sku) => {
                  goodsListTem.push(sku);
                });
              });
              const goodsTem = goodsListTem.filter((item) => item.goodsId == goods.skuId)[0];
              this.skuSpecsList = goodsTem.skuSpecsIndex.split(" ");
            })
            .finally(() => {
              this.loading = false;
            });
        }
        return visible;
      },
      set(visible) {
        this.$store.commit("cart/saveSpecsInfo", {
          visible,
        });
      },
    },
  },
  watch: {
    goods: function (data) {
      this.activityName = "";
      if (data.itemPromotion && data.itemPromotion.promotionType == "DIRECT_SELLING") {
        this.activityName = `直降${data.itemPromotion.preferentialValue}元`;
      }
      if (data.itemPromotion && data.itemPromotion.promotionType == "BUY_GIFTS") {
        this.activityName = `买${data.itemPromotion.buyGoodsQuantity}赠${data.itemPromotion.giftQuantity}`;
      }
      if (data.itemPromotion && data.itemPromotion.promotionType == "DISCOUNT") {
        this.activityName = `已享${data.itemPromotion.preferentialValue}折`;
      }
    },
  },
  created() {},
  methods: {
    async skuSpecsChange(index, spec) {
      this.$set(this.skuSpecsList, index, spec);
      const specsStr = this.skuSpecsList.join(" ");
      const goodsTem = this.specGroupInfo.filter((item) => item.specGroupName == specsStr)[0];
      if (goodsTem && goodsTem.skuResList[0]) {
        this.goodsTem = goodsTem.skuResList[0];
      }
    },
    async skuSpecsChangeConfirm() {
      const { list, skuSpecsList, specGroupInfo } = this;
      const specGoods = specGroupInfo.filter((item) => item.specGroupName == skuSpecsList.join(" "))[0].skuResList[0];

      // const listTem = [];
      // list.forEach((item) => {
      //   item.carItemList.forEach((item2) => {
      //     listTem.push(item2);
      //   });
      // });
      // const goodsInclude = listTem.filter((item) => item.skuId == specGoods.goodsId)[0];
      // if (goodsInclude) {
      //   let code = "";
      //   let exception = "";
      //   const res = await requestApi.post("sctrading/shoppingCart/updateGoodsQuantity", {
      //     skuId: specGoods.goodsId,
      //     quantity: Number((Number(goods.quantity) + Number(goodsInclude.quantity)).toFixed(6)),
      //   });

      //   code = res.code;
      //   exception = res.exception;
      //   loading.close();
      //   if (code !== "0") {
      //     this.$message.warning(exception);
      //     return;
      //   }
      // }

      if (specGoods.goodsId == this.goods.skuId) {
        this.visibleSync = false;
        return;
      }

      const loading = this.$loading({
        lock: false,
        text: "切换中...",
      });

      const { msg, code } = await requestApi.post("sctrading/shoppingCart/updateGoodsById", {
        newGoodsId: specGoods.goodsId,
        skuId: this.goods.skuId,
      });

      loading.close();

      if (code != "0") {
        this.$message.error(msg);
        return;
      }

      const goodsIdChecked = [];
      list.forEach((item) => {
        item.carItemList.forEach((goods) => {
          if (goods.checked) {
            goodsIdChecked.push(goods.skuId);
          }
        });
      });

      this.$store.commit("cart/saveGoodsIdChecked", goodsIdChecked);
      this.$emit("loadData");
      this.visibleSync = false;
      loading.close();
    },
    /* 进入店铺 */
    goUrl(url) {
      window.open(`${this.scLink}${url}`);
    },
  },
};
